export default __webpack_public_path__ + "static/28-95a3f98585e019f6de4fd5fea3f74e1c.webp";